export const de = {
  // Navigation
  navigation: {
    dashboard: 'Dashboard',
    profiles: 'Profile',
    reports: 'Berichte',
    sites: 'Standorte',
    settings: 'Einstellungen',
    account: 'Konto',
    logout: 'Abmelden',
    switchAccount: 'Konto wechseln',
    accountSettings: 'Kontoeinstellungen',
    events: 'Ereignisse',
    users: 'Benutzer',
    allEvents: 'Alle Ereignisse',
    eventGenerator: 'Ereignis-Generator',
    reportingHub: 'Report-Hub',
    musterReport: 'Musterbericht',
    anomalies: 'Anomalien',
    peopleOnSite: 'Personen auf Standort',
    userTimeAndAttendance: 'Benutzer Zeit und Anwesenheit',
    companyTimeAndAttendance: 'Unternehmen Zeit und Anwesenheit',
    companyTimeAndAttendanceGroups: 'Unternehmen Zeit und Anwesenheit Gruppen',
    expiringProfiles: 'Expiring Profiles & Certificates',
    firstInLastOut: 'Erster Eingang / Letzter Ausgang',
    boscaAdminDailyProfiles: 'Tägliche Profile am Standort',
    boscaAdminDailyCompanies: 'Unternehmen nach Tag',
    deletedProfiles: 'Gelöschte Profile',
    manageProfiles: 'Profile verwalten',
    poweredBy: 'Unterstützt von...',
    integrations: 'Integrationen',
    procoreExplorer: 'Procore Explorer',
    visitors: 'Besucher',
    visitorAttendance: 'Besucher-Anwesenheit',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Willkommen',
    overview: 'Übersicht',
    welcomeBack: 'Willkommen zurück',
    hi: 'Hallo',
    onlineSites: 'Online Standorte',
    profilesOnSitesNow: 'Profile auf Standorten jetzt',
    events: 'Ereignisse',
    profileActivity: 'Profilaktivität',
    uniqueProfilesPerDay: 'Eindeutige Profile pro Tag',
    peopleOnSite: 'Personen auf Standort',
    gatesOnline: 'Tore online',
    notifications: 'Benachrichtigungen',
    activityOverview: 'Aktivitätsübersicht',
    actions: 'Aktionen',
    chooseASite: 'STANDORT AUSWÄHLEN',
    toViewAndMakeActions: 'um anzuzeigen und Aktionen durchzuführen',
    registerAProfile: 'Profil registrieren',
    manageProfiles: 'Profile verwalten',
    manageDoors: 'Türen verwalten',
    holdOpenAllDoors: 'Alle Türen öffnen',
    openAllDoors: 'Alle Türen öffnen',
    closeAllDoors: 'Alle Türen schließen',
    confirmHoldOpenTitle: 'Alle Türen öffnen?',
    confirmHoldOpenMessage: 'Alle Türen bleiben offen, bis jemand sie mit „Alle Türen zurücksetzen“ zurücksetzt.',
    cancel: 'Abbrechen',
    sitesAreOpen: 'Standorte sind offen',
    openSince: 'Offen seit',
    siteOpenAlertClickHint: 'Klicken Sie, um zu „Türen verwalten“ zu gelangen',
    musterReport: 'Musterbericht',
    period: 'Zeitraum',
    peopleOnAllSites: 'Personen auf allen Standorten',
    totalCompaniesOnSites: 'Gesamte Unternehmen auf Standorten',
    activities: 'Aktivitäten',
    entered: 'betreten',
    left: 'verlassen',
    justNow: 'Gerade eben',
    hour: 'Stunde',
    hours: 'Stunden',
    ago: 'vor',
    today: 'Heute',
    yesterday: 'Gestern',
    piperSquare: 'Piper Square',
    // Overview page
    lastUpdated: 'Zuletzt aktualisiert',
    live: 'Live',
    todaysActivity: 'Heutige Aktivität',
    vsYesterday: 'vs gestern',
    activityTrends: 'Aktivitätstrends',
    activityTrendsSubheader: 'Eindeutige Profile pro Tag über alle Standorte (letzte 7 Tage)',
    peopleBySite: 'Personen nach Standort',
    peopleBySiteSubheader: 'Aktuelle Verteilung über Standorte',
    peopleByCompany: 'Personen nach Unternehmen',
    companiesOnSite: 'Unternehmen vor Ort',
    moreCompanies: 'weitere Unternehmen',
    noSitesWithActiveProfiles: 'Keine Standorte mit aktiven Profilen',
    noCompaniesWithActiveProfiles: 'Keine Unternehmen mit aktiven Profilen',
    alertsAndInsights: 'Warnungen & Einblicke',
    issuesRequiringAttention: 'Probleme, die Aufmerksamkeit erfordern',
    expiringProfiles: 'Ablaufende Profile',
    expiringCertificates: 'Ablaufende Zertifikate',
    errors24h: 'Fehler (24h)',
    warnings24h: 'Warnungen (24h)',
    allSystemsHealthy: 'Alle Systeme gesund - keine Probleme erkannt',
    person: 'Person',
    people: 'Personen',
    profiles: 'Profile',
  },

  // Account Popover
  accountPopover: {
    accountSettings: 'Kontoeinstellungen',
    switchAccount: 'Konto wechseln',
    logout: 'Abmelden',
    email: 'E-Mail',
    account: 'Konto',
  },

  // Site Selector
  siteSelector: {
    site: 'Standort',
    allSites: 'Alle Standorte',
  },

  // Language
  language: {
    english: 'Englisch',
    german: 'Deutsch',
    language: 'Sprache',
    changeLanguage: 'Sprache ändern',
  },

  // Notifications
  notifications: {
    title: 'Benachrichtigungen',
    youHaveUnreadMessages: 'Sie haben {count} ungelesene Nachrichten',
    markAllAsRead: 'Alle als gelesen markieren',
    new: 'Neu',
    beforeThat: 'Davor',
    viewAll: 'Alle anzeigen',
    // Sample notification messages
    yourOrderIsPlaced: 'Ihre Bestellung ist aufgegeben',
    waitingForShipping: 'warten auf Versand',
    answeredToYourComment: 'hat auf Ihren Kommentar zu Minimal geantwortet',
    youHaveNewMessage: 'Sie haben eine neue Nachricht',
    unreadMessages: '5 ungelesene Nachrichten',
    youHaveNewMail: 'Sie haben neue E-Mail',
    sentFrom: 'gesendet von Guido Padberg',
    deliveryProcessing: 'Lieferung wird bearbeitet',
    yourOrderIsBeingShipped: 'Ihre Bestellung wird versendet',
  },

  // Common
  common: {
    create: 'Create',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    edit: 'Edit',
    refresh: 'Refresh',
    search: 'Search',
    searchPlaceholder: 'Search...',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading...',
    noData: 'No data',
    notAvailable: 'N/A',
    dashboard: 'Dashboard',
  },

  // Login splash
  login: {
    pageTitle: 'Anmelden | CloudLoq',
    signIn: 'Anmelden',
    tryAgain: 'Erneut versuchen',
    errorDescription: 'Beim Starten der Anmeldung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  },

  // Profiles
  profiles: {
    title: 'Profiles',
    sitesProfiles: 'Sites profiles',
    siteLabel: 'Site',
    refreshProfiles: 'Refresh Profiles',
    tabs: {
      local: 'Local Profiles',
      skillkoReadyShort: 'Skillko - Ready',
      skillkoReadyLong: 'Skillko - Ready for Registration',
      skillkoNotReady: 'Skillko - Not Ready',
      sitepassShort: 'SitePass',
      sitepassReadyLong: 'SitePass - Ready for Registration',
      deleted: 'Deleted Profiles',
    },
    searchProfiles: 'Search Profiles',
    searchMinCharsPlaceholder: 'Please enter 3 or more characters',
    crossTabSearch: {
      alsoFoundIn: 'Auch gefunden in',
      matchCount: '{count} in {tab}',
      noResultsHere: 'Auf diesem Tab stimmen keine Profile mit Ihrer Suche überein.',
    },
    registerNewProfile: 'Register New Profile',
    registerNewProfileWithoutSkillko: 'Neues Profil registrieren (ohne Skillko)',
    importDraftProfiles: 'Import Draft Profiles',
    info: {
      localManaged: 'Local profiles managed directly in CloudLoq',
      deletedAll:
        'Deleted profiles - View all profiles that have been deleted from the system',
      skillkoReady: 'Skillko profiles ready for registration',
      skillkoNotReady:
        'Skillko profiles that need additional requirements before registration',
      sitepassReady: 'SitePass profiles ready for registration',
    },
    skillkoReady: {
      noPhotoHint: 'Kein Profilfoto in Skillko',
      noPhotoRibbon: 'Kein Foto',
    },
    badge: {
      skillko: 'Skillko',
      skillkoTooltip: 'Profil von Skillko synchronisiert',
      skillkoMerge: 'Merge aus Skillko möglich',
      skillkoMergeTooltip: 'Ein passendes Skillko-Profil ist zur Induktion bereit',
      skillkoMergeTooltipWithTeam: 'Skillko-Treffer: {teamName} (ID {skillkoId})',
    },
    card: {
      noAccessLevel: 'No access level',
      deletedProfile: 'Deleted Profile',
      deletedAt: 'Deleted',
      notReadyForRegistration: 'Not Ready For Registration',
      requirementsNotMet: 'Requirements not met',
      unknownReason: 'Unknown reason',
      failedRules: 'Failed Rules',
      failureReason: 'Failure Reason',
      view: 'View',
      noProfiles: 'No profiles to display',
      noProfilesDescription:
        'No profiles match your current filters or search criteria.',
    },
    table: {
      profile: 'Profil',
      firstName: 'First Name',
      lastName: 'Last Name',
      company: 'Company',
      skillkoTeam: 'Skillko Team',
      status: 'Status',
      access: 'Access',
      reasons: 'Reasons',
      source: 'Source',
      actions: 'Actions',
      teamUnavailable: 'N/A',
      showMoreRules: '+{count} more',
      allValidationIssues: 'All Validation Issues',
    },
    snackbar: {
      loadLocalFailed: 'Failed to load local profiles',
      loadDeletedFailed: 'Failed to load deleted profiles',
      loadSkillkoFailed: 'Failed to load Skillko profiles',
      loadSitepassFailed: 'Failed to load SitePass profiles',
      skillkoThisProfile: 'Dieses Profil',
      skillkoRefreshing: '{name} wird von Skillko aktualisiert…',
      skillkoRefreshSuccess: '{name} ist mit Skillko auf dem neuesten Stand.',
      skillkoRefreshFailed: '{name} konnte nicht von Skillko aktualisiert werden.',
      skillkoMovedToReady: '{name} ist jetzt bereit zur Registrierung.',
      skillkoMovedToNotReady: '{name} ist nicht mehr bereit zur Registrierung.',
      skillkoStillNotReady: '{name} ist aktuell, aber noch nicht bereit zur Registrierung.',
    },
    actionsMenu: {
      openInSkillko: 'In Skillko öffnen',
      register: 'Registrieren',
      resetAntipassback: 'Anti-Passback zurücksetzen',
      resetAntipassbackSuccess: 'Anti-Passback erfolgreich zurückgesetzt.',
      resetAntipassbackFailed: 'Anti-Passback konnte nicht zurückgesetzt werden.',
      mergeWithSkillko: 'Mit Skillko mergen',
      linkToSkillko: 'Mit Skillko verknüpfen',
      refreshFromSkillko: 'Von Skillko aktualisieren',
    },
    linkDialog: {
      title: 'Profil mit Skillko verknüpfen',
      description:
        'Geben Sie die numerische Skillko-Benutzer-ID ein. Die E-Mail des Profils in CloudLoq muss mit der Skillko-E-Mail übereinstimmen, sonst wird die Verknüpfung abgelehnt. Danach werden die Daten von Skillko synchronisiert.',
      skillkoIdLabel: 'Skillko-Profil-ID',
      skillkoIdPlaceholder: 'z. B. 12345',
      skillkoAutomaticExpiry: 'Skillko-Automatikablauf für dieses Profil verwenden',
      confirm: 'Verknüpfen und synchronisieren',
      invalidSkillkoId: 'Geben Sie eine gültige Skillko-Profil-ID ein (positive ganze Zahl).',
      success:
        'Profil mit Skillko verknüpft und synchronisiert. Zertifikate und Bereitschaft folgen den Skillko-Daten.',
      failed: 'Profil konnte nicht mit Skillko verknüpft werden.',
    },
    mergeDialog: {
      title: 'Mit Skillko mergen',
      description:
        'Verknüpft das lokale UI-Profil mit dem passenden Skillko-Benutzer und synchronisiert Zertifikate und Bereitschaft von Skillko. Prüfen Sie die Änderungen vor der Bestätigung.',
      skillkoMatch: 'Skillko-Treffer: {name} — {teamName} (ID {skillkoId})',
      columns: {
        field: 'Feld',
        before: 'Aktuell',
        after: 'Nach Merge',
      },
      fields: {
        source: 'Quelle',
        integrationId: 'Skillko-Integration',
        firstName: 'Vorname',
        lastName: 'Nachname',
        certificates: 'Zertifikate',
      },
      certificatesAdded: '{count} Zertifikat(e) werden von Skillko synchronisiert: {names}',
      afterMergeNote:
        'Nach dem Merge ist dieses Profil mit Skillko verknüpft und das Duplikat verschwindet aus der Skillko-Ready-Ansicht.',
      skillkoAutomaticExpiry: 'Skillko-Automatikablauf für dieses Profil verwenden',
      confirm: 'Mergen und synchronisieren',
      loadFailed: 'Merge-Vorschau konnte nicht geladen werden.',
      success: 'Profil erfolgreich mit Skillko gemergt und synchronisiert.',
      failed: 'Profil konnte nicht mit Skillko gemergt werden.',
    },
    importDialog: {
      firstNameRequired: 'First Name is required',
      lastNameRequired: 'Last Name is required',
      parseFailed: 'Failed to parse CSV',
      noProfilesToImport: 'No profiles to import',
      fixValidationErrors: 'Please fix validation errors before importing',
      queueSuccess: 'Successfully queued {count} profiles for import',
      importFailed: 'Failed to import profiles',
      dateOfBirth: 'Date of Birth',
      phone: 'Phone',
      safePassExpiry: 'SafePass Expiry',
      manualHandlingExpiry: 'Manual Handling Expiry',
      error: 'Error',
      valid: 'Valid',
      csvInstructions:
        'Upload a CSV file with the following columns: First Name, Last Name, Email, date of birth, Contact Number, SafePass/CSR Expiry, Manual Handling Expiry, Company Name',
      selectCsvFile: 'Select CSV File',
      validProfiles: 'valid profiles',
      profilesWithErrors: 'profiles with errors - please fix before importing',
      validationErrorsInRows: 'Validation errors found in {count} row(s):',
      row: 'Row',
      andMoreErrors: 'and {count} more errors',
      preview: 'Preview',
      validProfilesOutOf: 'valid profiles out of {count}',
      selectCsvToPreview: 'Select a CSV file to preview profiles',
      import: 'Import',
    },
    form: {
      pageTitleCreate: 'Create profile | CloudLoq',
      pageTitleEdit: 'Edit profile | CloudLoq',
      pageTitleView: 'Profil ansehen | CloudLoq',
      pageTitleRegister: 'Register a profile | CloudLoq',
      pageTitleRegisterSitepass: 'Register SitePass Profile | CloudLoq',
      breadcrumbAddNew: 'Add a new profile',
      breadcrumbEdit: 'Edit Profile',
      breadcrumbView: 'Profil ansehen',
      breadcrumbRegister: 'Register a profile',
      breadcrumbRegisterSitepass: 'Register SitePass Profile',
      newProfile: 'New Profile',
      profile: 'Profile',
      newSitepassProfile: 'New SitePass Profile',
      retryInductionSuccess:
        'Retry induction initiated successfully. The profile will be processed shortly.',
      retryInductionFailed: 'Failed to retry induction',
      activating: 'Activating...',
      activateProfile: 'Activate Profile',
      deleteProfileTooltip:
        'You can delete the profile and start again by creating a new profile if necessary',
      deleteProfile: 'Delete profile',
      retryInductionTooltip: 'Retry the induction process for this profile',
      retrying: 'Retrying...',
      retryInduction: 'Retry Induction',
      refreshFromSkillko: 'Refresh from Skillko',
      refreshFromSkillkoTooltip:
        'Pull the latest profile and certificate data from Skillko and update this form.',
      refreshingFromSkillko: 'Refreshing...',
      refreshFromSkillkoSuccess: 'Skillko data refreshed successfully.',
      refreshFromSkillkoFailed: 'Failed to refresh data from Skillko.',
      forceUpdateFromSkillko: 'Von Skillko erzwingen',
      forceUpdateFromSkillkoTooltip:
        'Nur für Admins. Überschreibt das gespeicherte Skillko-Profil und aktualisiert danach jedes abweichende Feld dieses registrierten Profils.',
      forcingUpdateFromSkillko: 'Aktualisiere...',
      forceUpdateFromSkillkoSuccess: 'Von Skillko aktualisiert: {fields}.',
      forceUpdateFromSkillkoUnchanged:
        'Skillko-Profil wurde überschrieben. Die Felder dieses Profils stimmen bereits überein.',
      forceUpdateFromSkillkoFailed: 'Erzwungenes Update von Skillko ist fehlgeschlagen.',
      forceUpdateFromSkillkoConfirmTitle: 'Update von Skillko erzwingen?',
      forceUpdateFromSkillkoConfirmBody:
        'Das gespeicherte Skillko-Profil wird von Skillko überschrieben. Danach werden Name, Telefon, Geburtsdatum, Notfallkontakt, Firma, Rolle, Foto, Ablaufdatum und Zertifikate aktualisiert, wenn sie abweichen. Die E-Mail bleibt unverändert.',
      forceUpdateFromSkillkoConfirm: 'Update erzwingen',
      unableActivate: 'Unable to Activate Profile:',
      unableSaveDraft: 'Unable to Save as Draft:',
      unableSaveChanges: 'Unable to Save Changes:',
      pictureProcessingErrorTitle: 'Profile Picture Processing Error:',
      pictureProcessingErrorBody:
        'There was an issue processing your profile picture during registration. Simply upload a new profile picture and the system will automatically retry the process to ensure proper facial recognition functionality.',
      notReadyForInduction: 'Profile Not Ready for Induction',
      notReadyDescription:
        "This profile doesn't meet all induction requirements. You can still register them, but they may not have all required qualifications. The expiry date has been set to 1 month from now.",
      inductionExpiryPassed: 'Induction Expiry Passed',
      inductionExpiredOn: "This profile's induction expired on",
      verifyBeforeProceeding: 'Please verify the information before proceeding.',
      tabs: {
        editProfile: 'Edit Profile',
        viewProfile: 'Profil ansehen',
        profileActivities: 'Profile Activities',
        changeHistory: 'Change History',
      },
      deletedReadOnly: 'This profile has been deleted. All fields are read-only and cannot be edited.',
      viewOnlyCannotRegister:
        'Sie können diesen Datensatz ansehen, haben jedoch keine Berechtigung, ein Profil zu registrieren oder zu bearbeiten.',
      confirmDeleteTitle: 'Confirm Delete Profile',
      confirmDeleteDescriptionPrefix: 'Are you sure you want to delete the profile for',
      confirmDeleteDescriptionSuffix: 'This action cannot be undone.',
      delete: 'Delete',
      skillkoFieldBadgeTooltip:
        'Synced from Skillko - update it there so your change is not overwritten on the next sync.',
      skillkoBannerText:
        'This profile is managed by Skillko. Fields marked with the cloud icon are normally kept in sync with Skillko every 15 minutes - changes made here may be overwritten. For permanent changes, update the data in Skillko, or refresh Skillko data to pull the latest information.',
      skillkoEditConfirmTitle: 'Editing Skillko-managed data',
      skillkoEditConfirmBody:
        '{fields} is normally kept in sync with Skillko. Saving this change here may be overwritten the next time this profile syncs with Skillko.',
      skillkoEditConfirmHint:
        'For a permanent change, update this information in Skillko instead. Or, if you want to discard your local edit and pull the latest data, refresh Skillko data now.',
      skillkoEditSaveAnyway: 'Save anyway',
      fieldFirstName: 'First name',
      fieldSurname: 'Surname',
      fieldDateOfBirth: 'Date of birth',
      fieldPhone: 'Phone',
      fieldNextOfKin: 'Emergency contact name',
      fieldNextOfKinPhone: 'Emergency contact number',
      fieldCompany: 'Company',
      fieldRole: 'Role',
      fieldPicture: 'Profile picture',
      fieldExpiry: 'Ablaufdatum',
    },
  },

  // Account
  account: {
    loadingAccounts: 'Loading accounts...',
    noAccessTitle: 'No Access Available',
    noAccessDescription:
      "You don't have access to any accounts. Please contact your administrator to request access.",
    createAccount: 'Create Account',
    signOut: 'Sign Out',
    chooseAccountToLogin: 'Choose account to login',
    accountName: 'Account Name',
    allowedDomainsOptional: 'Allowed Domains (optional)',
    accountNameHelper: '3-64 chars, letters/numbers/spaces/-/_',
    domainsHelper: 'Comma-separated, e.g. @acme.com,@partner.com',
    domainsMustStartWithAt: 'Each domain must start with @',
    accountCreatedSuccessfully: 'Account created successfully',
    failedToCreateAccount: 'Failed to create account',
    cloudloqLogo: 'CloudLoq Logo',
    settings: {
      general: 'General',
      security: 'Security',
      domainAccessDescription: 'Configure domain-based access control for this account',
      allowedDomainsHelper:
        'Comma-separated list of allowed email domains (e.g., @acme.com, @partner.com). Users will only see this account if their email matches one of these domains. Leave empty to restrict to whitelisted admins only.',
      saveDomains: 'Save Domains',
    },
  },

  // Sites
  sites: {
    all: 'All',
    skillko: {
      title: 'Skillko Settings',
      failedLoadCertificates: 'Failed to load certificates',
      siteIdRequired: 'Site ID is required',
      loginRequired: 'Please log in to access this page',
      siteDataNotFound: 'Site data not found',
      failedInitializePage: 'Failed to initialize page',
      unknownError: 'Unknown error',
      errorLoadingPageData: 'Error loading page data',
      accessRules: 'Access Rules',
      expiryRule: 'Expiry Rule',
      enableAutoExpiryTitle: 'Enable Auto Expiry for All Skillko Profiles',
      enableAutoExpiryMessage:
        'This will enable automatic expiry date calculation for ALL non-deleted Skillko-sourced profiles on this site and recalculate their expiry dates. This is a one-time bulk action and cannot be undone. Continue?',
      autoExpiryQueued:
        'Auto expiry has been queued. All Skillko profiles on this site will be updated in the background.',
      failedEnableAutoExpiry: 'Failed to enable auto expiry',
      recalculateInductionTitle: 'Recalculate induction readiness for this site',
      recalculateInductionMessage:
        'This queues a full recalculation of Skillko access induction rules for every team on this site. Profile readiness flags will be updated in the background. Continue?',
      inductionRecalculationQueued:
        'Induction recalculation has been queued. It may take a few minutes to complete.',
      failedQueueRecalculation: 'Fehler beim Einreihen der Induktions-Neuberechnung',
    },
    administrative: {
      bulkRetrySectionTitle: 'Massen-Retry Profil-Induktion',
      bulkRetrySectionIntro:
        'Stellt pro passendem Site-Profil einen Induktions-Retry in die Warteschlange (nur mit verknüpftem Tenant-Profil). Die Retries sind um ca. 0,5 s versetzt, um die Last auf dem Site-Controller zu reduzieren.',
      bulkRetryStatusesLabel: 'Einzubeziehende Profil-Status',
      bulkRetryStatusesHint:
        'Es werden nur nicht gelöschte Profile berücksichtigt, deren Status in dieser Liste steht. Namen entsprechen dem Server (z. B. InductionFailed).',
      bulkRetryQueueButton: 'Massen-Retry einreihen',
      bulkRetryConfirmTitle: 'Massen-Induktions-Retries einreihen?',
      bulkRetryConfirmWarning:
        'Dies kann über die Zeit viele Anfragen an die Site-Box erzeugen. Stellen Sie sicher, dass das Zugangssystem die Last verkraftet.',
      bulkRetryConfirmStatuses: 'Berücksichtigte Status:',
      bulkRetryConfirmAction: 'Retries einreihen',
      bulkRetrySuccess: '{enqueued} Induktions-Retries eingeplant. Sie laufen gestaffelt im Hintergrund.',
      bulkRetryFailed: 'Massen-Retry konnte nicht eingeplant werden',
      bulkRetrySelectStatus: 'Mindestens einen Profil-Status auswählen',
      pipelineSideBySideTitle: 'Profil vs FaceScanner (gleicher Tag)',
      pipelineSideBySideIntro:
        'Zeilen aus den normalen Profil-Tabellen und den FaceScanner-Spiegeltabellen für einen Kalendertag. Beide Seiten nutzen dieselbe serverseitige Sortierung. Große Tage werden begrenzt.',
      pipelineDayLabel: 'Tracking-Tag',
      pipelineEntityLabel: 'Datensatz',
      pipelineEntityActivity: 'Profilaktivität',
      pipelineEntityState: 'Profil-Status-Tracking',
      pipelineEntityAnomaly: 'Profilaktivitäts-Anomalien',
      pipelineSortLabel: 'Sortieren nach',
      pipelineSortProfileId: 'ProfileId',
      pipelineSortEventTimeUtc: 'EventTimeUtc (Aktivität)',
      pipelineSortZoneId: 'ZoneId (Status)',
      pipelineSortAnomalyName: 'AnomalyName (Anomalien)',
      pipelineLoadButton: 'Tabellen laden',
      pipelineLoadingFailed: 'Pipeline-Vergleich konnte nicht geladen werden',
      pipelineProfileTableTitle: 'Profil (Standard)',
      pipelineFaceScannerTableTitle: 'FaceScanner',
      pipelineSortApplied: 'Sortierung: {field}',
      pipelineRowCap: 'Zeilenlimit pro Tabelle: {cap}',
      pipelineTruncatedProfile: 'Profil-Tabelle am Zeilenlimit abgeschnitten.',
      pipelineTruncatedFaceScanner: 'FaceScanner-Tabelle am Zeilenlimit abgeschnitten.',
      pipelineNoRows: 'Keine Zeilen',
      pipelineColId: 'Id',
      pipelineColProfileId: 'ProfileId',
      pipelineColProfileFullName: 'Name',
      pipelineColZoneId: 'ZoneId',
      pipelineColZoneName: 'Zone',
      pipelineColDoorId: 'DoorId',
      pipelineColActivityType: 'ActivityType',
      pipelineColEventTimeUtc: 'EventTimeUtc',
      pipelineColTimeInUtc: 'TimeInUtc',
      pipelineColTimeOutUtc: 'TimeOutUtc',
      pipelineColDoorControllerUserId: 'DoorControllerUserId',
      pipelineColHash: 'Hash',
      pipelineColOnSite: 'OnSite',
      pipelineColLastInUtc: 'LastInUtc',
      pipelineColLastOutUtc: 'LastOutUtc',
      pipelineColTimeOnSite: 'TimeOnSite',
      pipelineColHasAnomalies: 'HasAnomalies',
      pipelineColProfileActivityId: 'ProfileActivityId',
      pipelineColAnomalyName: 'AnomalyName',
      pipelineColTrackingDay: 'TrackingDay',
      pipelineComparePageTitle: 'Profil vs FaceScanner Vergleich',
      pipelineComparePageHeading: 'Profil vs FaceScanner',
      pipelineCompareBreadcrumbSites: 'Sites',
      pipelineCompareBreadcrumbCurrent: 'Profil vs FaceScanner',
      pipelineCompareBackToSite: 'Zurück zur Site',
      pipelineCompareLoading: 'Laden…',
      pipelineCompareAccessDenied: 'Keine Berechtigung für dieses Tool.',
      pipelineCompareSiteNotFound: 'Site nicht gefunden.',
      pipelineCompareLoadSiteFailed: 'Site konnte nicht geladen werden',
      pipelineCompareNavLabel: 'Profil vs FaceScanner (Tagesvergleich)',
    },
    manageDoors: {
      title: 'Türen verwalten',
      close: 'Schließen',
      unnamedDoor: 'Unbenannte Tür',
      deviceId: 'Geräte-ID',
      openIn: 'Eingang öffnen (15s)',
      openOut: 'Ausgang öffnen (15s)',
      heldOpenAlert: 'Türen werden offen gehalten',
      heldOpenAlertSince: 'Offen seit {time}',
      emptyTitle: 'Keine Türen an diesem Standort',
      emptyDescription: 'Türen erscheinen hier, sobald sie für diesen Standort konfiguriert sind.',
      resetAll: 'Alle Türen zurücksetzen',
      successHoldOpenAll: 'Alle Türen wurden dauerhaft geöffnet.',
      successResetAll: 'Alle Türen wurden zurückgesetzt.',
      successOpenDoor: 'Tür wurde geöffnet.',
      failedLoadDoors: 'Türen konnten nicht geladen werden.',
      failedHoldOpenAll: 'Alle Türen konnten nicht geöffnet werden.',
      failedResetAll: 'Alle Türen konnten nicht zurückgesetzt werden.',
      failedOpenDoor: 'Tür konnte nicht geöffnet werden.',
    },
  },

  // Reports
  reports: {
    noRecords: 'No records for the following report',
    exportCsv: 'Export CSV',
    exportPdf: 'PDF exportieren',
    exportPdfUnavailable: 'PDF-Export ist für diesen Bericht derzeit nicht verfügbar',
    details: 'Details',
    anomaly: 'ANOMALY',
    anomaliesDetected: 'Anomalies detected',
    onSite: 'ON SITE',
    entry: 'ENTRY',
    exit: 'EXIT',
    event: 'EVENT',
    peopleCount: '{count} people',
    group: 'Group',
    company: 'Company',
    totalTime: 'Total Time',
    filters: 'Filters',
    from: 'From',
    to: 'To',
    boscaAdminDaily: {
      presetToday: 'Heute',
      presetYesterday: 'Gestern',
      presetThisWeek: 'Diese Woche',
      presetLastWeek: 'Letzte Woche',
      presetThisMonth: 'Diesen Monat',
      presetLastMonth: 'Letzten Monat',
      presetCustom: 'Benutzerdefiniert',
      customFrom: 'Von',
      customTo: 'Bis',
      profilesMatrixSubtitle:
        'Zeilen: Profile; Spalten: Kalendertage im gewählten Bereich. Jede Zelle zeigt die gesamte Anwesenheitszeit dieses Profils an diesem Tag (jede Spalte nur dieser Tag).',
      profilesMatrixSubtitleFlipped:
        'Zeilen: Kalendertage im gewählten Bereich; Spalten: Profile. Jede Zelle zeigt die gesamte Anwesenheitszeit dieses Profils an diesem Tag (jede Spalte nur dieser Tag).',
      companiesMatrixSubtitle:
        'Zeilen: Unternehmen; Spalten: Kalendertage. Jede Zelle: wie viele unterschiedliche Profile der Firma an diesem Tag (keine Summe über den Bereich).',
      matrixCaptionProfiles: '{profileCount} Profile × {dayCount} Tage',
      matrixCaptionCompanies: '{companyCount} Unternehmen × {dayCount} Tage',
      searchProfileMatrixPlaceholder: 'Suche nach Profil, Firma, Job',
      searchCompanyMatrixPlaceholder: 'Suche nach Firmenname',
      columnProfile: 'Profil',
      columnCompany: 'Unternehmen',
      columnJobTitle: 'Berufsbezeichnung',
      columnProfiles: 'Profile',
      columnDate: 'Datum',
      selectSiteWarning: 'Wählen Sie eine Site (nicht „Alle“), um diesen Bericht zu laden.',
      activityTimelineRequiresSingleDay:
        'Wählen Sie einen einzelnen Tag, um den Aktivitätsverlauf anzuzeigen.',
      dayCellPeopleHint: 'Unterschiedliche Profile dieses Unternehmens mit Tracking an diesem Tag.',
      dayCellTimeHint: 'Gesamte Anwesenheitszeit an diesem Tag für dieses Unternehmen (Summe der Tracking-Datensätze).',
      profileDayCellTimeHint: 'Gesamte Anwesenheitszeit an diesem Tag für dieses Profil.',
      exportCsvPeople: 'Personen',
      exportCsvTime: 'Zeit',
      flipAxisTooltip: 'Achse tauschen (Zeilen und Spalten vertauschen)',
      pdfDetailSite: 'Site',
      pdfDetailDateRange: 'Zeitraum',
    },
  },

  // Procore
  procore: {
    title: 'Procore API Explorer',
    loadConfig: 'Load Config',
    saveConfig: 'Save Config',
    noConnectionConfigured: 'No Procore connection configured. Configure it in Account Settings.',
    configurationSaved: 'Configuration saved to database',
    failedSaveConfiguration: 'Failed to save configuration',
    configurationReloaded: 'Configuration reloaded from database',
    accessTokenRequired: 'Access Token is required (or configure connection in Account Settings)',
    companyIdRequired: 'Valid Company ID is required (or configure site mapping in Site Settings)',
    projectIdRequired: 'Valid Project ID is required (or configure site mapping in Site Settings)',
  },

  // Validation
  validation: {
    profilePictureRequired: 'Profile picture is required',
    profilePictureInvalid:
      'Profile picture data is invalid or empty. Please upload a valid picture.',
    profilePictureTooSmall:
      'Profile picture data is too small or invalid. Please upload a valid picture.',
    emailRequired: 'Email is required',
    emailInvalid: 'Enter a valid email address',
    firstNameRequired: 'First name is required',
    dateOfBirthRequired: 'Date of Birth is required',
    surnameRequired: 'Surname is required',
    phoneRequired: 'Phone number is required',
    companyRequired: 'Company is required',
    accessRequired: 'Access is required',
    roleRequired: 'Role is required',
    validFromAfterExpiresAt: 'Valid From date cannot be after Expires At date',
    expiresAtBeforeValidFrom: 'Expires At date cannot be before Valid From date',
  },

  // Data Grid
  dataGrid: {
    columns: 'Columns',
    toggleColumns: 'Toggle Columns',
    showAll: 'Show All',
    hideAll: 'Hide All',
    sortedAscending: 'sorted ascending',
    sortedDescending: 'sorted descending',
  },

  // Export PDF
  exportPdf: {
    generated: 'Generated',
    data: 'Data',
    noData: 'No data',
    emptyMessage: 'No data available for this report',
    yes: 'Yes',
    no: 'No',
    filters: 'Filters',
  },
};
